import React from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/SectionDivider";

const REASONS = [
  {
    n: "01",
    title: "Currency Risk",
    body:
      "The Rupee has depreciated over 40% against the USD over the past decade — eroding purchasing power on every wealth held in INR.",
  },
  {
    n: "02",
    title: "Domestic Concentration",
    body:
      "Most HNI wealth sits in Indian real estate, equities or FDs — all India-correlated assets exposed to the same macro cycle.",
  },
  {
    n: "03",
    title: "Limited Access",
    body:
      "India represents barely 3% of global market capitalisation. The other 97% of the world's compounding remains out of reach.",
  },
  {
    n: "04",
    title: "Regulatory Risk",
    body:
      "Policy changes can re-price entire domestic asset classes overnight. Global diversification reduces single-jurisdiction exposure.",
  },
  {
    n: "05",
    title: "Inheritance Complexity",
    body:
      "Cross-border estate planning is materially cleaner with international structures held in the client's own name.",
  },
];

const Opportunity = () => {
  return (
    <section
      id="opportunity"
      data-testid="opportunity-section"
      className="relative bg-[#111111] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow testId="opportunity-eyebrow">The Opportunity</Eyebrow>
          <h2
            data-testid="opportunity-heading"
            className="font-serif-display text-[#C9960C] text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-4xl leading-[1.05]"
          >
            Why Indian HNIs Must Think Beyond India
          </h2>
          <p className="mt-8 max-w-2xl text-[#F8F6F0]/70 leading-relaxed text-base sm:text-lg">
            A discreet truth quietly understood by India&apos;s most established business families: real diversification begins where the rupee ends.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {REASONS.map((r, idx) => (
            <Reveal key={r.n} delay={idx * 0.08}>
              <article
                data-testid={`opportunity-card-${idx + 1}`}
                className="group relative bg-[#1C1C1C] border border-[#C9960C]/40 border-t-2 border-t-[#C9960C] p-8 md:p-10 h-full transition-all duration-500 hover:-translate-y-1 hover:border-[#C9960C] hover:shadow-2xl hover:shadow-[#C9960C]/5"
              >
                <div className="flex items-baseline justify-between mb-6">
                  <span className="font-serif-display text-[#C9960C]/70 text-3xl">{r.n}</span>
                  <span className="h-px w-12 bg-[#C9960C]/40 group-hover:w-20 transition-all duration-500" />
                </div>
                <h3 className="font-serif-display text-[#F5D485] text-2xl mb-4 tracking-tight">
                  {r.title}
                </h3>
                <p className="text-[#F8F6F0]/75 text-[15px] leading-relaxed">
                  {r.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Opportunity;
